/**
 * "Kjøp nå med Vipps" (mission M-20261016-vipps-ekspress). Installs once per page.
 *
 * Click on the theme's own button.bjerve-vipps__knapp[data-vipps-ekspress] (no other markup starts a flow):
 *   produkt  presses the product form's own add-to-cart button, so the options app (Globo) validates and adds
 *            exactly as for "Legg i handlekurv". The outcome is read from the add requests themselves (/cart/add or
 *            /cart/add.js, whoever sends them: the theme's product form or Globo), not from a theme event, because
 *            Globo may add lines on its own. A visible option error means the app stopped the add and shows why;
 *            a failed add shows the theme's own message; no result within 10 s of the press shows the timeout text.
 *            Only after a successful add does the cart token go to the worker.
 *   kurv / skuff  the cart as it is.
 * The cart token from /cart.js goes to the worker in a top-level form POST, after a Kilde write or pickup sync still in
 * flight has settled (at most 3 s, inside the deadline; see kildeSettled). The worker sends the customer to Vipps
 * Logg inn and on into Shopify checkout with the details filled in, or back to /cart?vipps=..., where
 * snippets/bjerve-vipps-melding.liquid shows the notice.
 *
 * Measurement, without any personal data: vipps_ekspress_klikk { plassering } and vipps_ekspress_retur { utfall }
 * go to Shopify.analytics.publish (pixels) and, only when the visitor has allowed analytics, to GA4 through the
 * page's own gtag, as bjerve-produktvalg-maaling does. Mirrored to window.bjerveVippsEkspress.logg.
 */
(function () {
  'use strict';
  if (window.bjerveVippsEkspress) return;
  var state = (window.bjerveVippsEkspress = { logg: [] });

  var GA4 = 'G-7VG89T3XDF';
  // Fixed here, never read from the page: markup anyone can put in a description must not redirect the cart token.
  var START_URL = 'https://vipps-login.bjerveur.workers.dev/start';
  var KNAPP = 'button.bjerve-vipps__knapp[data-vipps-ekspress]';
  // Spec: no result within 10 s of the press (add and cart read together) shows the timeout text, nothing goes to
  // Vipps.
  var DEADLINE_MS = 10000;
  // After the last add request settles, wait this long for a follow-up add (Globo adds option lines separately).
  var ADD_QUIET_MS = 1000;
  var POLL_MS = 50;
  // Longest hold of the cart token for the Kilde write (M-20261017-google-klikk-kjop, spec edge case 13).
  var KILDE_WAIT_MS = 3000;
  var ADD_PATH = /\/cart\/add(\.js)?$/;
  var OPTION_ERRORS = '.gpo-container .help-block.error, .gpo-container .messages';
  // GA4 names of the three places (spec AC-2); the worker keeps the short form-field values.
  var PLASSERING = { produkt: 'produkt', kurv: 'handlekurv', skuff: 'kurvskuff' };

  var adds = { started: 0, pending: 0, failed: 0, settledAt: 0 };

  /** fetch and XHR take a string, a URL or a Request. */
  function isAdd(input) {
    try {
      var url = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
      return Boolean(url) && ADD_PATH.test(new URL(url, window.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function addStarted() {
    adds.started += 1;
    adds.pending += 1;
  }

  function addSettled(ok) {
    adds.pending = Math.max(0, adds.pending - 1);
    if (!ok) adds.failed += 1;
    adds.settledAt = Date.now();
  }

  // Every add request on the page goes through one of these two, whoever sends it.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var result = nativeFetch.apply(this, arguments);
      if (isAdd(input)) {
        addStarted();
        result.then(
          function (r) {
            addSettled(r.ok);
          },
          function () {
            addSettled(false);
          }
        );
      }
      return result;
    };
  }
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.bjerveVippsAdd = isAdd(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.bjerveVippsAdd) {
      addStarted();
      this.addEventListener('loadend', function () {
        addSettled(this.status >= 200 && this.status < 300);
      });
    }
    return xhrSend.apply(this, arguments);
  };

  function track(name, data) {
    var published = false;
    var sent = false;
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        a.publish(name, data);
        published = true;
      }
    } catch (e) {
      published = false;
    }
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() && typeof window.gtag === 'function') {
        var params = { send_to: GA4, transport_type: 'beacon' };
        Object.keys(data).forEach(function (k) {
          params[k] = data[k];
        });
        window.gtag('event', name, params);
        sent = true;
      }
    } catch (e) {
      sent = false;
    }
    state.logg.push({ navn: name, data: data, tid: Date.now(), publisert: published, sendt_ga4: sent });
  }

  function busy(btn, on) {
    if (on) {
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('aria-busy');
    }
  }

  /** Shows the text named by kind ('feil' or 'tid') under the button, or hides it when kind is null. */
  function message(btn, kind) {
    var area = btn.closest('.bjerve-vipps');
    var el = area && area.querySelector('.bjerve-vipps__feil');
    if (!el) return;
    el.textContent = kind ? el.getAttribute('data-tekst-' + kind) : '';
    el.hidden = !kind;
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () {
        reject(new Error('timeout'));
      }, ms);
      promise.then(
        function (v) {
          clearTimeout(t);
          resolve(v);
        },
        function (e) {
          clearTimeout(t);
          reject(e);
        }
      );
    });
  }

  function readCart() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return nativeFetch(base + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function optionErrorShown() {
    var els = document.querySelectorAll(OPTION_ERRORS);
    for (var i = 0; i < els.length; i += 1) {
      if (els[i].getBoundingClientRect().height > 0 && els[i].textContent.trim()) return true;
    }
    return false;
  }

  /**
   * Presses the theme's add button and settles with 'added' (every add request it caused succeeded), 'stopped'
   * (none started and the options app shows an error, or the add button is disabled) or 'failed' (an add answered
   * with an error, which the theme shows), or rejects with a timeout at the deadline.
   */
  function addThroughForm(btn, deadline) {
    var form = btn.closest('product-form');
    var add = form && form.querySelector('button[name="add"]');
    if (!add || add.disabled) return Promise.resolve('stopped');
    // An add still in flight from "Legg i handlekurv" is this press's add: the theme ignores the click below while
    // its own submit runs (product-form.js aria-disabled), so no second add starts to wait for.
    var base = { started: adds.started - adds.pending, failed: adds.failed };
    return new Promise(function (resolve, reject) {
      var timer = setInterval(function () {
        var now = Date.now();
        var started = adds.started > base.started;
        var failed = adds.failed > base.failed;
        // A failed add ends the press at once (spec: the button is usable again within 500 ms); only a successful
        // one waits out the quiet window for a follow-up option line.
        if (started && adds.pending === 0 && (failed || now - adds.settledAt >= ADD_QUIET_MS)) {
          clearInterval(timer);
          resolve(failed ? 'failed' : 'added');
        } else if (!started && optionErrorShown()) {
          clearInterval(timer);
          resolve('stopped');
        } else if (now >= deadline) {
          clearInterval(timer);
          reject(new Error('timeout'));
        }
      }, POLL_MS);
      add.click();
    });
  }

  /**
   * The worker writes back the attribute set it reads, so a Kilde write (assets/bjerve-kilde.js) or a pickup sync
   * (assets/bjerve-henting.js, spec A5) still in flight would be lost: hold the token until both settle, at most
   * KILDE_WAIT_MS and never past the deadline. Fail open.
   */
  function kildeSettled(deadline) {
    var until = Math.min(Date.now() + KILDE_WAIT_MS, deadline);
    function pending() {
      var k = window.bjerveKilde;
      var h = window.bjerveHenting;
      var busy = (Boolean(k) && k.status === 'venter') || (Boolean(h) && h.status === 'venter');
      return busy && Date.now() < until;
    }
    if (!pending()) return Promise.resolve();
    return new Promise(function (resolve) {
      var timer = setInterval(function () {
        if (pending()) return;
        clearInterval(timer);
        resolve();
      }, POLL_MS);
    });
  }

  function post(action, token, kilde) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = action;
    f.hidden = true;
    [['kurv', token], ['kilde', kilde]].forEach(function (pair) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = pair[0];
      i.value = pair[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function start(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var kilde = btn.getAttribute('data-vipps-ekspress');
    track('vipps_ekspress_klikk', {
      plassering: Object.prototype.hasOwnProperty.call(PLASSERING, kilde) ? PLASSERING[kilde] : kilde,
    });
    message(btn, null);
    busy(btn, true);
    var deadline = Date.now() + DEADLINE_MS;
    var step = kilde === 'produkt' ? addThroughForm(btn, deadline) : Promise.resolve('added');
    step
      .then(function (result) {
        if (result !== 'added') return null;
        return withTimeout(readCart(), Math.max(0, deadline - Date.now()));
      })
      .then(function (cart) {
        if (!cart || !cart.item_count || !cart.token) {
          busy(btn, false);
          return null;
        }
        return kildeSettled(deadline).then(function () {
          post(START_URL, cart.token, kilde);
        });
      })
      .catch(function (e) {
        busy(btn, false);
        message(btn, e && e.message === 'timeout' ? 'tid' : 'feil');
      });
  }

  function trackReturn() {
    var el = document.querySelector('[data-vipps-melding][data-utfall]');
    if (el) track('vipps_ekspress_retur', { utfall: el.getAttribute('data-utfall') });
  }

  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var close = target.closest('[data-vipps-melding-lukk]');
    if (close) {
      close.closest('[data-vipps-melding]').hidden = true;
      return;
    }
    var btn = target.closest(KNAPP);
    if (!btn) return;
    ev.preventDefault();
    start(btn);
  });

  // Back from Vipps restores the page from the back-forward cache with the button still busy.
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    document.querySelectorAll(KNAPP + '[aria-busy="true"]').forEach(function (btn) {
      busy(btn, false);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackReturn);
  } else {
    trackReturn();
  }
})();
